var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 1l7 7-7 7","stroke":"#fff","stroke-width":"2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }